import { useContext } from "react";

import { AppContext } from "@/stores/appStore";

export const useRegisteredSecurityKey = () => {
  const { state } = useContext(AppContext);

  return {
    isSecurityKeyRegistered: state.onboardingProgress?.registeredSecurityKey,
  };
};
